import ReactSelect from "../ReactSelect/ReactSelect";

import { getImageUrl } from "Common/utils/ImageDomain";

const TwoColumnSegmentCard = ({
    cardLabel,
    singleColumnData,
    columnData,
    handleColumnData,
    showError,
    setColumnData,
    setEventData,
    setIndex,
    setImageUrl,
    columnLabel,
    dropdownKeyName,
    textKey,
    imageKey,
    contentType,
    toggle,
    isEditable
}) => {
    return (
        <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
            <div className="mb-4 xl:col-span-12">
                <label className="inline-block mb-2 text-base font-medium">
                    {cardLabel}
                </label>
                <ReactSelect
                    disabled={!isEditable}
                    options={contentType}
                    isSearchable={false}
                    isMulti={false}
                    placeholder={"Please select content type"}
                    contentType={singleColumnData}
                    handleContentChange={handleColumnData}
                    name={dropdownKeyName}
                    id={"content-type1"}
                />
                {showError(dropdownKeyName)}
            </div>
            {singleColumnData?.value === contentType[1]?.value && (
                <div className="mb-4 xl:col-span-12">
                    <label className="inline-block mb-2 text-base font-medium">
                        {columnLabel}
                    </label>
                    <textarea
                        disabled={!isEditable}
                        data-type="text"
                        rows={4}
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        placeholder="Enter column one text"
                        value={columnData[textKey]}
                        onChange={(e) =>
                            handleColumnData(textKey, e.target.value)
                        }
                    />
                    {showError(textKey)}
                </div>
            )}

            {singleColumnData?.value === contentType[2]?.value && (
                <div>
                    <div className="flex my-4">
                        {columnData[imageKey] ? (
                            <div className="flex items-center">
                                <div className="relative w-40 h-40 ">
                                    <img
                                        src={getImageUrl(columnData[imageKey])}
                                        className="rounded "
                                        style={{
                                            objectFit: "contain",
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    />
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "0px",
                                            right: "6px",
                                            fontSize: "22px",
                                            cursor: "pointer",
                                        }}
                                        onClick={isEditable ? () => {
                                            setColumnData((prev) => ({
                                                ...prev,
                                                [imageKey]: "",
                                            }));
                                            setColumnData((prev) => ({
                                                ...prev,
                                                [imageKey]: "",
                                            }));
                                        } : null}
                                    >
                                        ×
                                    </span>
                                </div>
                                <div className="h-3 ml-3">
                                    <button
                                        onClick={isEditable ? () => {
                                            setImageUrl(imageKey);
                                            toggle();
                                            setEventData(undefined);
                                            setIndex(undefined);
                                        } : null}
                                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                    >
                                        Change column one imageurl
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <button
                                onClick={isEditable ? () => {
                                    setImageUrl(imageKey);
                                    toggle();
                                    setEventData(undefined);
                                    setIndex(undefined);
                                } : null}
                                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                            >
                                Add column one imageurl
                            </button>
                        )}
                    </div>
                    {showError(imageKey)}
                </div>
            )}
        </div>
    );
};

export default TwoColumnSegmentCard;
